"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useI18n = exports.initLocalization = exports.isTranslationSupported = exports.changeLanguage = exports.getTranslationFormat = exports.translate = void 0;
const i18next_1 = __importDefault(require("i18next"));
const react_i18next_1 = require("react-i18next");
const i18next_chained_backend_1 = __importDefault(require("i18next-chained-backend"));
const i18next_http_backend_1 = __importDefault(require("i18next-http-backend"));
const i18next_resources_to_backend_1 = __importDefault(require("i18next-resources-to-backend"));
const en_us_json_1 = __importDefault(require("../locales/en-us.json"));
const fr_ma_json_1 = __importDefault(require("../locales/fr-ma.json"));
const pt_pt_json_1 = __importDefault(require("../locales/pt-pt.json"));
const constants_1 = require("../../api/constants");
const translate = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return t;
};
exports.translate = translate;
const getTranslationFormat = (value, namespace) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return t(value);
};
exports.getTranslationFormat = getTranslationFormat;
const changeLanguage = (lang) => {
    i18next_1.default.changeLanguage(lang === null || lang === void 0 ? void 0 : lang.toLowerCase());
};
exports.changeLanguage = changeLanguage;
const isTranslationSupported = (languageCode) => {
    const isExist = constants_1.SUPPORTED_LANGUAGES === null || constants_1.SUPPORTED_LANGUAGES === void 0 ? void 0 : constants_1.SUPPORTED_LANGUAGES.includes(languageCode === null || languageCode === void 0 ? void 0 : languageCode.toLowerCase());
    return isExist;
};
exports.isTranslationSupported = isTranslationSupported;
const initLocalization = (loadFromBackend, url, urlParams) => {
    const resources = {
        en: en_us_json_1.default,
        fr: fr_ma_json_1.default,
        pt: pt_pt_json_1.default
    };
    (0, constants_1.initializeConfigJson)(url, urlParams);
    i18next_1.default
        .use(react_i18next_1.initReactI18next)
        .use(i18next_chained_backend_1.default)
        .init({
        fallbackLng: 'en',
        ns: ['translation'],
        defaultNS: 'translation',
        interpolation: {
            escapeValue: false,
        },
        // saveMissing: true,
        load: 'currentOnly',
        debug: false,
        react: {
            useSuspense: false,
        },
        backend: {
            backends: [i18next_http_backend_1.default, (0, i18next_resources_to_backend_1.default)(resources)],
            backendOptions: loadFromBackend ? [
                {
                    loadPath: `${url}/translations/{{lng}}/{{ns}}.json${urlParams}`,
                }
            ] : []
        },
    });
};
exports.initLocalization = initLocalization;
const useI18n = () => {
    const { i18n } = (0, react_i18next_1.useTranslation)();
    return i18n;
};
exports.useI18n = useI18n;
